import(/* webpackMode: "eager", webpackExports: ["SearchScrollTopButtonClient"] */ "/builds/empiriecom/core/frontend/turborepo/apps/shopping/src/app/[lang]/(shop)/(search)/SearchScrollTopButton.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/builds/empiriecom/core/frontend/turborepo/packages/shared/src/ui/ErrorBoundary/ErrorBoundary.tsx");
